import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sgAbs',
  standalone: false,
})
export class SgAbsPipe implements PipeTransform {
  transform(value: any): number {
    return Math.abs(value);
  }
}
